export default __webpack_public_path__ + "static/media/42d8827ad003c6636a22ee8f508567401578075716093.6a6ff235.webp";